import dynamic from "next/dynamic";
import React from "react";
const ServiceTabs = dynamic(() => import("./ServiceTabs"));
const ServiceHero = dynamic(() => import("./ServiceHero"));
const CommonCtaSection = dynamic(
  () => import("../common/CTASection/CommonCtaSection")
);

const Service = ({ data }) => {
  const commonCtaData = data?.find((block) => block?.type === "cta");
  return (
    <>
      <main className="main-wrapper services-page-middle">
        <article className="wrapper-inner">
          <ServiceHero data={data} />
          <ServiceTabs data={data} />
          <CommonCtaSection data={commonCtaData} />
        </article>
      </main>
    </>
  );
};

export default Service;
